import axios from "axios";

const api=axios.create({
  baseURL: "https://pixell.leadmi.pixell.cc/api",
});

export const api2=axios.create({
  baseURL: "https://roletabackend.pixell.cc/api/",
});

export default api;
